import { cva } from 'class-variance-authority';

export const wrapperClasses = cva(['flex w-auto items-center gap-1'], {
  variants: {
    size: {
      small: 'py-0-5 rounded-xs px-1',
      medium: 'rounded-md px-2 py-1'
    }
  },
  defaultVariants: {
    size: 'medium'
  }
});
